(() => {
  const SELECTORS = {
    section: ".js-you-might-also-like",
    content: ".js-ymal-content",
    item: ".js-ymal-item",
    slider: ".js-ymal-slider",
    pagination: ".js-ymal-pagination"
  };

  const PARAMS = {
    section: "section_id",
    limit: "limit",
    product: "product_id"
  };

  const MOBILE_MQ = "(max-width: 767px)";
  let initialized = false;

  async function init() {
    if (initialized) return;
    initialized = true;

    const sections = [...document.querySelectorAll(SELECTORS.section)];
    if (!sections.length) return;

    await Promise.all(sections.map((section) => setupSection(section)));

    if (window.themeCore?.LazyLoadImages?.init) {
      window.themeCore.LazyLoadImages.init();
    }
  }

  async function setupSection(section) {
    const productId = section.dataset.productId;
    const limit = section.dataset.limit || "4";
    const sectionId = section.id;
    const useRecommendations = section.hasAttribute("data-product-recommendations");

    if (useRecommendations && productId) {
      const requestUrl = window.themeCore?.objects?.routes?.product_recommendations_url;

      if (requestUrl) {
        try {
          const url = new URL(window.location.origin + requestUrl);
          url.searchParams.set(PARAMS.section, sectionId);
          url.searchParams.set(PARAMS.product, productId);
          url.searchParams.set(PARAMS.limit, limit);

          const response = await fetch(url.toString());
          const text = await response.text();
          const html = document.createElement("div");
          html.innerHTML = text;

          const fetchedContent = html.querySelector(SELECTORS.content);
          const currentContent = section.querySelector(SELECTORS.content);
          const items = fetchedContent ? [...fetchedContent.querySelectorAll(SELECTORS.item)] : [];

          if (!fetchedContent || !items.length) {
            if (!currentContent?.querySelector(SELECTORS.item)) {
              section.closest(".shopify-section")?.remove();
              return;
            }
          } else if (currentContent) {
            currentContent.innerHTML = fetchedContent.innerHTML;
          }
        } catch (error) {
          console.error(error);
        }
      }
    }

    reveal(section);
    setupCarousel(section);
  }

  function setupCarousel(section) {
    const slider = section.querySelector(SELECTORS.slider);
    const pagination = section.querySelector(SELECTORS.pagination);
    if (!slider || !pagination) return;

    const slides = [...slider.querySelectorAll(SELECTORS.item)];
    if (slides.length < 2) {
      pagination.hidden = true;
      return;
    }

    pagination.innerHTML = "";
    slides.forEach((_, index) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "ymal__dot" + (index === 0 ? " is-active" : "");
      dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
      dot.addEventListener("click", () => {
        slider.scrollTo({ left: slides[index].offsetLeft, behavior: "smooth" });
      });
      pagination.appendChild(dot);
    });

    const syncPagination = () => {
      const isMobile = window.matchMedia(MOBILE_MQ).matches;
      pagination.hidden = !isMobile;
      if (!isMobile) return;

      const sliderLeft = slider.scrollLeft;
      let activeIndex = 0;
      let closest = Infinity;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - sliderLeft);
        if (distance < closest) {
          closest = distance;
          activeIndex = index;
        }
      });

      [...pagination.children].forEach((dot, index) => {
        dot.classList.toggle("is-active", index === activeIndex);
      });
    };

    slider.addEventListener("scroll", () => {
      window.requestAnimationFrame(syncPagination);
    }, { passive: true });

    window.addEventListener("resize", syncPagination);
    syncPagination();
  }

  function reveal(section) {
    section.classList.remove("is-loading");
    section.classList.add("is-ready");
  }

  if (window.themeCore && window.themeCore.loaded) {
    init();
  } else {
    document.addEventListener("theme:all:loaded", init, { once: true });
  }
})();
